export default __webpack_public_path__ + "static/media/CBMERP_LOGO.c5134d88.png";